import React, { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useQueryParams from "../hooks/useQueryParams";
import { useAssetsVariables } from "../contexts/assets-variables";
import useAvailableWarehouses from "../hooks/capture/useAvailableWarehouses";
import useAvailableCostCenters from "../hooks/capture/useAvailableCostCenters";
import InventoryFiltersModal from "./InventoryFiltersModal";
import {
  DEFAULT_INVENTORY_FILTER_PARAMS,
  inventorySelectionFromParam,
  inventorySelectionFromVariables,
} from "../hooks/capture/useInventoryFilters";

const INVENTORY_LABELS = {
  showOnlyInStockItems: "In Warehouse",
  showOutOfWarehouse: "Out of Warehouse",
  showAllInventory: "All Inventory",
  showStorePageScope: "Available Now",
};

const costCenterLabelFor = costCenter =>
  `${costCenter.costCenterName || ""}${
    costCenter.costCenterCode ? ` ${costCenter.costCenterCode}` : ""
  }`.trim();

export default function ActiveFilterChips({
  sx,
  paramKeys = DEFAULT_INVENTORY_FILTER_PARAMS,
  inventoryFromParams = false,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const searchParams = useQueryParams();
  const assetsVariables = useAssetsVariables();
  const variables = assetsVariables?.variables;
  const warehouses = useAvailableWarehouses();
  const costCenters = useAvailableCostCenters();

  const warehouseId = searchParams.get(paramKeys.warehouseId);
  const costCenterId = searchParams.get(paramKeys.costCenterId);

  const selected = inventoryFromParams
    ? inventorySelectionFromParam(searchParams.get(paramKeys.inventory))
    : inventorySelectionFromVariables(variables);

  const inventoryLabel = INVENTORY_LABELS[selected];
  const hasMultipleWarehouses = warehouses.length > 1;
  const warehouseLabel =
    hasMultipleWarehouses
      ? warehouseId && warehouseId !== "all"
        ? warehouses.find(w => w.warehouseId === warehouseId)?.name
        : "All Warehouses"
      : null;
  const hasMultipleCostCenters = costCenters.length > 1;
  const selectedCostCenter = costCenters.find(cc => String(cc.id) === String(costCenterId));
  const costCenterLabel =
    hasMultipleCostCenters && selectedCostCenter
      ? costCenterLabelFor(selectedCostCenter)
      : hasMultipleCostCenters
      ? "All Cost Centers"
      : null;

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  return (
    <>
      <Box display="flex" flexWrap="wrap" alignItems="center" gap={1} sx={sx}>
        <Chip
          label={inventoryLabel}
          size="small"
          deleteIcon={<ExpandMoreIcon fontSize="small" />}
          onClick={handleOpen}
          onDelete={handleOpen}
        />
        {warehouseLabel && (
          <Chip
            label={warehouseLabel}
            size="small"
            deleteIcon={<ExpandMoreIcon fontSize="small" />}
            onClick={handleOpen}
            onDelete={handleOpen}
          />
        )}
        {costCenterLabel && (
          <Chip
            label={costCenterLabel}
            size="small"
            deleteIcon={<ExpandMoreIcon fontSize="small" />}
            onClick={handleOpen}
            onDelete={handleOpen}
          />
        )}
      </Box>
      {modalOpen && (
        <InventoryFiltersModal
          onClose={handleClose}
          paramKeys={paramKeys}
          inventoryFromParams={inventoryFromParams}
        />
      )}
    </>
  );
}
